import axios from "axios";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { Card, Col, Row } from "react-bootstrap";
import { authHeader } from "../../services/auth-header";
import { BASE_URL } from "../../services/Api";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import ViewPumpDomesticQuotation from "./PumpDomesticQuotation/ViewPumpDomesticQuotation";
import ViewPumpInternationalQuotation from "./PumpInternationalQuotation/ViewPumpInternationalQuotation";
import ViewAraiMfgQuotation from "./AraiMfgQuotation/ViewAraiMfgQuotation";
import ViewAraiMfgDomesticQuotation from "./AraiMfgDomesticSQ/ViewAraiMfgDomesticSQ";

const ViewSOQuotation = () => {
  const navigate = useNavigate();
  const { id, pointindex } = useParams();
  const [productType, setProductType] = useState();
  const [productCategory, setProductCategory] = useState();
  const [enquiryData, setEnquiryData] = useState();

  async function getData() {
    try {
      const response = await axios.get(`${BASE_URL}quotation/findById/${id}`, {
        headers: authHeader(),
      });

      console.log(response);
      setEnquiryData(response.data);

      setProductType(response.data.quotationtype);
      setProductCategory(response.data.quotationcategory);
    } catch (error) {
      console.log(error);
    }
  }

  function PageDisplay() {
    if (productType === "Pump Spare") {
      if (productCategory === "Domestic") {
        return <ViewPumpDomesticQuotation enquiryData={enquiryData} />;
      } else if (productCategory === "International") {
        return <ViewPumpInternationalQuotation enquiryData={enquiryData} />;
      }
    } else if (productType === "Manufacturing") {
      if (productCategory === "Domestic") {
        return <ViewAraiMfgDomesticQuotation enquiryData={enquiryData} />;
      } else if (productCategory === "International") {
        return <ViewAraiMfgQuotation enquiryData={enquiryData} />;
      }
    } else {
      return null;
    }
  }

  async function deleteEnquiry() {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(BASE_URL + "quotation/delete/" + id, {
            headers: authHeader(),
          })
          .then((response) => {
            if (response.data.length === 0) {
              Swal.fire(
                "Warning",
                "Enquiry present in another module. Delete operation has been cancelled.",
                "warning"
              );
            } else {
              console.log(response.data);
              navigate(`/quotationIndexTable/${pointindex}`);
              Swal.fire("Deleted!", "Deleted successfully.", "success");
            }
          })
          .catch((error) => {
            Swal.fire("Error", error.response.data, "error");
          });
      }
    });
  }

  async function cancelHandler() {
    try {
      const response = await axios.get(
        `${BASE_URL}quotation/cancelQuotationStatus/${id}`,
        {
          headers: authHeader(),
        }
      );

      navigate(`/quotationIndexTable/${pointindex}`);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getData();
  }, []);

  console.log(enquiryData);

  return (
      <Card className="card">
        <Card.Header className="card-header">
          <h6>VIEW</h6>
          <div>
            <strong>Type:</strong> {productType} | <strong>Category:</strong> {productCategory}
          </div>
          <div className="view-buttons">
            {enquiryData?.status === "Open" &&
              enquiryData?.status !== "Cancelled" && (
                <Link to={`/sqtosoconversion/${id}`}>
                  <button className="button-70">Convert TO SO</button>
                </Link>
              )}

            {enquiryData?.status !== "Cancelled" && (
              <Link to={`/editQuotation/${id}/${pointindex}`}>
                <button className="button-70">EDIT</button>
              </Link>
            )}

            {enquiryData?.status === "Open" &&
              enquiryData?.status !== "Cancelled" && (
                <button className="button-70" onClick={cancelHandler}>
                  Cancel
                </button>
              )}
            <Link to={`/quotationIndexTable/${pointindex}`}>
              <button className="button-70">BACK</button>
            </Link>
          </div>
        </Card.Header>
        {PageDisplay()}

        {/* <Card.Body>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select Quotation Type:</Form.Label>
                <Form.Select
                  onChange={(e) => {
                    setProductType(e.target.value);
                  }}
                  value={productType}
                  disabled={productType ? true : false}
                >
                  <option value="">--Please choose an option--</option>
                  <option value="Pump Spare">Pump Spare</option>
                  <option value="Manufacturing">Manufacturing</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Label>Select a Quotation Category:</Form.Label>
                <Form.Select
                  disabled={
                    !productType
                      ? true
                      : false || productCategory
                        ? true
                        : false
                  }
                  value={productCategory}
                  onChange={(e) => setProductCategory(e.target.value)}
                >
                  <option value="">--Please choose an option--</option>
                  <option value="Domestic">Domestic</option>
                  <option value="International">International</option>
                </Form.Select>
              </Form.Group>
            </Col>

          </Row>
        </Card.Body> */}
      </Card>
  );
};

export default ViewSOQuotation;
